import { InjectionToken, type Provider } from '@angular/core';

/**
 * Where the generated icon sprites are served from, relative to the app's base
 * href (or absolute). Apps copy `projects/ui/assets/icons` into their own assets
 * via `angular.json`; override this only if they publish them elsewhere.
 */
export const UI_ICON_SPRITE_BASE = new InjectionToken<string>('UI_ICON_SPRITE_BASE', {
  providedIn: 'root',
  factory: () => 'assets/icons',
});

/** Overrides the sprite base path, e.g. `provideUiIcons('static/icons')`. */
export function provideUiIcons(basePath: string): Provider {
  return { provide: UI_ICON_SPRITE_BASE, useValue: basePath };
}
